// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoContainer[data-v-afb92fce]{padding:10px}.infoContainer .top p[data-v-afb92fce]{text-align:center;margin:0}.infoContainer .top .smallTxt[data-v-afb92fce]{font-size:12px}.infoContainer .left .van-button[data-v-afb92fce],.infoContainer .right .van-button[data-v-afb92fce]{margin:0 0 10px}.infoContainer .van-cell[data-v-afb92fce]{border:1.5px solid #1989fa;padding:4px 16px;border-radius:8px;box-shadow:inset 0 0 5px 0 #969799}[data-v-afb92fce]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
